<template>
    <b-card no-body class="wrapper" v-if="currentAppointment">
        <template v-slot:header>
            <h4>Current Appointment</h4>
        </template>
        <b-card-body v-if="!showCancel">
            <div class="label">Appointment Date</div>
            <div class="text">{{ currentAppointment.start | date }}</div>
            <div class="label">Appointment Time</div>
            <div class="text">{{ currentAppointment.start | time }}</div>
            <div class="label">Service</div>
            <div class="text">{{ currentAppointment.bookingsService.displayName}}</div>
            <div class="label">Staff</div>
            <div class="text">{{ currentAppointment.bookingsStaff.displayName}}</div>
            <div class="label">Attending</div>
            <div class="text">{{ vendorsAttending}}</div>
            <b-button variant="warning" @click="showCancel = true"><font-awesome-icon class="mr-1" icon="times-circle" />Cancel Appointment</b-button>
        </b-card-body>
        <b-card-body v-if="showCancel">
            <div class="label">Cancel Reason</div>
            <b-select placeholder="please select" value-field="id" text-field="name"
                    :options="lookups.bookingsAppointmentCanceledReasons" v-model="cancelReasonId"></b-select>
            <b-button class="mr-2 mt-3" variant="warning" @click="showCancel = false"><font-awesome-icon icon="times" /></b-button>
            <b-button :disabled="!cancelReasonId || loading" class="mr-2 mt-3" variant="danger" @click="cancel">
                <font-awesome-icon v-if="loading == false" class="mr-1" icon="times-circle" />
                    <b-spinner small v-if="loading == true" label="Busy"></b-spinner>
                Cancel
            </b-button>
        </b-card-body>
    </b-card>
</template>

<script>

import bookingsService from '../../../services/bookings.service'; 

export default ({
    props: {
        companyId: null,
        appointments: null,
        vendors: null,
        lookups: null,
    },
    watch: {
        appointments: function () {
            this.currentAppointment = this.appointments.filter(x => x.isCurrent == true)[0];
            this.history = this.appointments.filter(x => x.isCurrent == false);
        },
        vendors: function(){
            let attending  = this.vendors.filter(x => x.isAttendingAppointment == true);
            this.vendorsAttending = attending.map(x => x.fullname).join(", ") ?? "";
        },
        lookups: function(){
            console.log(this.lookups.bookingsAppointmentCanceledReasons)
        }
    },
    data: function () {
        return {
            currentAppointment: null,
            history: null,
            vendorsAttending: null,
            showCancel: false,
            cancelReasonId: null,
            loading: false,
        }
    },
    methods: {
        cancel(){
            let data = {
                companyId: this.companyId,
                bookingsAppointmentCanceledReasonId: this.cancelReasonId
            }
            this.loading = true;
            bookingsService.cancelBookingsAppointment(data).then((result) => {
                if (result){
                    this.$parent.loadData();
                    this.loading = false;
                }else{
                    alert("Error cancelling Appointment");
                    this.loading = false;
                }
                
            });
        }
    }
})
</script>
<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
.wrapper {
  margin-top: 10px;
}
h4 {
  margin-bottom: 0;
}
</style>